export const ASSESSMENT_PATH = "/assessments/:id";
